import { ref, computed } from "vue";
import { createMessageWithParams } from "../utils/validation/index.mjs";
import { loadLocaleData } from "../localization/index.mjs";
const localeCache = /* @__PURE__ */ new Map();
const currentLocale = ref("en");
export function useLocalization() {
  const loadLocale = async (locale) => {
    if (localeCache.has(locale)) {
      return localeCache.get(locale);
    }
    try {
      const localeData = await loadLocaleData(locale);
      localeCache.set(locale, localeData);
      return localeData;
    } catch (error) {
      console.warn(`Failed to load locale ${locale}:`, error);
      return null;
    }
  };
  const setLocale = async (locale) => {
    if (!locale) {
      console.warn("Unable to set form locale: ", locale);
      return;
    }
    await loadLocale(locale);
    currentLocale.value = locale;
  };
  const getValidationMessage = (ruleName, customMessage) => {
    if (customMessage) {
      return customMessage;
    }
    let localeData = localeCache.get(currentLocale.value);
    return localeData?.messages[ruleName] || null;
  };
  const createLocalizedMessage = (ruleName, customMessage) => {
    const template = getValidationMessage(ruleName, customMessage);
    if (!template) {
      return null;
    }
    return createMessageWithParams(template);
  };
  return {
    currentLocale: computed(() => currentLocale.value),
    setLocale,
    getValidationMessage,
    createLocalizedMessage,
    loadLocale
  };
}
